import fr from './fr';
import en from './en';
import es from './es';

const locales = {
    fr,
    en,
    es,
};

export default locales;
